import { render, staticRenderFns } from "./viewSkills.vue?vue&type=template&id=81b29aee&scoped=true"
import script from "./viewSkills.vue?vue&type=script&lang=js"
export * from "./viewSkills.vue?vue&type=script&lang=js"
import style0 from "./viewSkills.vue?vue&type=style&index=0&id=81b29aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b29aee",
  null
  
)

export default component.exports